export default __webpack_public_path__ + "static/media/pokedex.68867e86.png";